/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_MacInputs */

const en_gc_resources_download_mac = /** @type {(inputs: Gc_Resources_Download_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS`)
};

const zh_gc_resources_download_mac = /** @type {(inputs: Gc_Resources_Download_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS`)
};

/**
* | output |
* | --- |
* | "macOS" |
*
* @param {Gc_Resources_Download_MacInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_mac = /** @type {((inputs?: Gc_Resources_Download_MacInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_MacInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_mac(inputs)
	return zh_gc_resources_download_mac(inputs)
});
export { gc_resources_download_mac as "gc.resources.download.mac" }